import ZJApp from '../app'
import apis from './src/apis'
import views from './src/views'

const utils = ZJApp.ZJUtils;

//注册 API 到全局命名空间中
utils.each(apis, (v,k)=>ZJApp.ZJApis[k] = v);

const getView = function(uri) {
    const that = this;
    let path = uri.path;
    return new Promise(function (resolve, reject) {
        let arr = path.split('/');
        let controller = arr[1];
        let action = arr[2] || 'index';
        let view = null;
        utils.each(views, x=>{
            if (typeof x === 'object' && x.controller && x.action &&
                x.controller.toLowerCase() == controller.toLowerCase() &&
                x.action.toLowerCase() == action.toLowerCase()) {
                view = x;
                return false;
            }
        });
        if (view) {
            resolve(view);
        }
        else {
            reject('在插件 ' + that.name + ' 中未找到路径 ' + path);
        }
    });
};


// 每一个插件必须具有 name, getView 属性。
export default {
    name: 'IndustrialMonitoring',
    displayName: '产业监测',
    getView,
    apis,
    views
}
